<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.academicYear')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.ac_year_id"
            :options="academic_year_list"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_year_id')">
            {{ errors.first('ac_year_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.mainProgram')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.acp_id"
            :options="main_program_list"
            :disabled="!model.ac_year_id"
            @change="fetchTerm"
          ></a-select>
          <div class="validate" v-if="errors.has('acp_id')">
            {{ errors.first('acp_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.academicTerm')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.ac_term_id"
            :options="ac_term_list"
            :show-search="true"
            option-filter-prop="children"
            :filter-option="
              (input, option) =>
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
            "
            @change="fetchStudentScoringEntry"
          ></a-select>
          <div class="validate" v-if="errors.has('ac_term_id')">
            {{ errors.first('ac_term_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.scoringCycle')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.scoring_cycle_id"
            :options="scoringCycle"
          ></a-select>
          <div class="validate" v-if="errors.has('scoring_cycle_id')">
            {{ errors.first('scoring_cycle_id') }}
          </div>
        </div>
      </div>
      <div class="row form-group">
        <div class="col-md-12">
          <label class="required ts-text-xs">{{
            $t('totalScoreGenerate.cycleValue')
          }}</label>
          <a-select
            style="width: 100%"
            v-model="model.cycle_value"
            :options="scoringValue"
          ></a-select>
          <div class="validate" v-if="errors.has('cycle_value')">
            {{ errors.first('cycle_value') }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 text-right ts-whitespace-no-wrap">
          <ts-button class="mr-2" @click.prevent="$emit('closeModal')">{{
            $t('cancel')
          }}</ts-button>

          <ts-button color="primary" :waiting="waiting" @click.prevent="onSave">
            {{ $t('totalScoreGenerate.generate') }}
          </ts-button>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'totalStudentGenerate',
  data () {
    return {
      waiting: false,
      waiting_new: false,
      loading: false,
      errors: new Errors(),
      academic_year_list: [],
      main_program_list: [],
      ac_term_list: [],
      student_scoring_entry: [],
      model: {
        acp_id: null,
        ac_year_id: null,
        ac_term_id: null,
        scoring_cycle_id: null,
        cycle_value: null,
        program_structure_id_list: []
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    scoringCycle () {
      return _.uniqBy(
        this.student_scoring_entry.map(el => ({
          value: el.scoring_cycle_id,
          label: el.scoring_cycle_name
        })),
        'value'
      )
    },
    scoringValue () {
      return _.uniqBy(
        this.student_scoring_entry
          .filter(s => s.scoring_cycle_id == this.model.scoring_cycle_id)
          .map(el => ({
            value: el.cycle_value,
            label: el.cycle_value_text
          })),
        'value'
      )
    }
  },
  methods: {
    ...mapActions('generateTotalScore', [
      'getAcYear',
      'getMainProgram',
      'getTermByMainProgram',
      'getStudentScoringEntry',
      'store'
    ]),
    async fetchData () {
      this.loading = true
      await this.getAcYear({
        filter: {
          ac_status_id: '1,2,3'
        }
      })

        .then(response => {
          this.academic_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label:
              el.ac_year +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getMainProgram()
        .then(response => {
          this.main_program_list = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchTerm () {
      this.loading = true

      this.model.ac_term_id = null
      this.model.ac_term_id = null
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.model.program_structure_id_list = []

      this.getTermByMainProgram({ ...this.model })
        .then(response => {
          this.ac_term_list = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : ' ( Next ) ')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchStudentScoringEntry () {
      this.loading = true
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.model.program_structure_id_list = []

      this.getStudentScoringEntry({ ...this.model })
        .then(response => {
          this.student_scoring_entry = response.data.map(el => ({
            program_structure_id: el.program_structure_id,
            scoring_cycle_id: el.scoring_cycle_id,
            scoring_cycle_name: el.scoring_cycle_name,
            cycle_value: el.cycle_value,
            cycle_value_text: el.cycle_value_text
          }))

          var uniq = _.uniqBy(
            this.student_scoring_entry.map(el => ({
              program_structure_id: el.program_structure_id
            })),
            'program_structure_id'
          )

          this.model.program_structure_id_list = uniq.map(
            el => el.program_structure_id
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSave () {
      this.waiting = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('closeModal')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveNew () {
      this.waiting_new = true
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput () {
      this.model.acp_id = null
      this.model.ac_year_id = null
      this.model.ac_term_id = null
      this.model.scoring_cycle_id = null
      this.model.cycle_value = null
      this.model.program_structure_id_list = []
    }
  }
}
</script>
